import type { TripItineraryData } from 'tripPlanner/api/types'
import CruiseOfferDetailView from './CruiseOfferDetailView'
import useCruiseOfferDrawer from './useCruiseOfferDrawer'

interface Props {
  offer: App.CruiseOffer
  itineraryData?: TripItineraryData
  isStreaming?: boolean
  onSendMessage?: (message: string) => Promise<void>
  showTitleInContent?: boolean
}

function CruiseOfferDrawerContent({
  offer,
  itineraryData,
  isStreaming,
  onSendMessage,
  showTitleInContent,
}: Props) {
  const drawer = useCruiseOfferDrawer({
    offer,
    itineraryData,
    isStreaming,
    onSendMessage,
  })

  return (
    <CruiseOfferDetailView
      offer={offer}
      showTitleInContent={showTitleInContent}
      onDepartureItineraryAction={drawer.performDepartureItineraryAction}
      onCheckoutDeparture={drawer.selectDepartureForCheckout}
      occupancies={drawer.occupancies}
      setOccupancies={drawer.setOccupancies}
      hasItinerarySelection={drawer.hasItinerarySelection}
      itineraryDepartureId={drawer.itineraryDepartureId}
      itineraryItemId={drawer.itineraryItemId}
      isItineraryActionDisabled={drawer.isItineraryActionDisabled}
      isCheckoutDisabled={drawer.isCheckoutDisabled}
    />
  )
}

export default CruiseOfferDrawerContent
